Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.DefaultChartViewFactory
  constructor: (session, chartViewClass) ->
    @session = session
    @chartViewClass = chartViewClass

  canHandle: (widget) ->
    widget.get('type') == @chartViewClass.NAME

  create: (widget, data, isReadOnly, isResponsive) ->
    new @chartViewClass({
      widget: widget,
      data: data,
      session: @session,
      isReadOnly: isReadOnly,
      isResponsive: isResponsive
    })

